// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b751743b","453":"90b2701e","795":"0479affd"}[chunkId] + ".chunk.js";
};